import React, { useState } from "react";
import { View } from "react-native";
import NavigationBar from "../navigationBar/NavigationBar";
import NotificationCenter from "../notificationCenter/NotificationCenter";
import RightPanel from "../rightPanel/Rightpanel";
import { useHeaderLogic } from "./hooks/useHeaderLogic";
import { useAppSelector } from "@lib";

interface HeaderProps {
  screenName: string;
  displayName?: string;
  navigation: any;
}

export const Header: React.FC<HeaderProps> = ({
  screenName,
  displayName,
  navigation,
}) => {
  const [isNotificationVisible, setNotificationVisible] = useState(false);
  const [isRightPanelVisible, setRightPanelVisible] = useState(false);
  const { isConnected } = useAppSelector((state) => state.userReducer);

  const { handleNotificationPress, handleProfilePress, handleNavigation } =
    useHeaderLogic({
      navigation,
      setNotificationVisible,
      setRightPanelVisible,
      isConnected,
    });

  return (
    <View style={{ flex: 1, zIndex: 999 }}>
      <NavigationBar
        data={{ screenName, displayName }}
        barNavigation={navigation}
        onNotificationCenterPress={handleNotificationPress}
        onProfilePress={handleProfilePress}
        onNavigation={handleNavigation}
      />

      <NotificationCenter
        navigation={navigation}
        onNoInternet={() => {}}
        closeNotificationCenter={() => setNotificationVisible(false)}
        toggleNotificationCenter={() =>
          setNotificationVisible(!isNotificationVisible)
        }
        isNotificationCenterVisible={isNotificationVisible}
      />

      <RightPanel
        isModalVisible={isRightPanelVisible}
        toggleModal={() => setRightPanelVisible(!isRightPanelVisible)}
        closeRightPanel={() => setRightPanelVisible(false)}
        navigation={navigation}
        screenName={screenName}
        onNoInternet={() => {}}
      />
    </View>
  );
};
